<template>
    <div class="logout-page">
        <span>You're being redirected...</span>
    </div>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

export default {
    name: 'Logout',
    computed: {
        ...mapGetters( {
            branding: 'Website/branding',
        } ),
    },
    created() {
        this.$store.dispatch( 'User/logout' );
    },
};
</script>

<style scoped lang="scss">
.logout-page {
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-evenly;

    >* {
        margin: auto;
    }
}
</style>
